import React, { useState, useEffect, useMemo, SyntheticEvent } from 'react';
import { Helmet } from 'react-helmet-async';
import PageTitle from 'src/components/PageTitle';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import * as XLSX from "xlsx";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate, useParams } from 'react-router-dom';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import SearchIcon from '@mui/icons-material/Search';
import DateRangeIcon from '@mui/icons-material/DateRange';
import BusinessIcon from '@mui/icons-material/Business';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { authenticationService } from 'src/services/authentication.service';
import { deleteEntry, get, post,put } from 'src/services/httpClient.service';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { hasPermission } from 'src/components/Permissions/hasPermission';
import { getResponsiveStyles, isMobileScreen } from 'src/common/utils/responsive';
import { useWalletContext } from 'src/components/walletcontexthook';
import InfoIcon from '@mui/icons-material/Info';



const Multiplesubscriptions = () => {
  const { showSnackbar } = useSnackbar();
  const theme = useTheme();
  const styles = getResponsiveStyles(theme);
  const [isMobile, setIsMobile] = useState(isMobileScreen(theme));
  const [deviceloading,setdeviceloading] = useState(false)
  const { fetchOperatorDetails } = useWalletContext();

  const [hasCustomPasswordAccess, setHasCustomPasswordAccess] = useState(false);
  
    
      const fetchApplicationConfig = async () => {
      try {
        const response = await get(
          `${API_URL}/api/application-config/vendor/${vendorId}`
        );
    
        setHasCustomPasswordAccess(
          response?.hasCustomPasswordAccess || false
        );

        
        console.log(
          "enableUserWallet",
          response?.enableUserWallet
        );
      } catch (error) {
        console.error("Error fetching application config", error);
      }
    };
    
    useEffect(() => {
      
      fetchApplicationConfig();
    }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileScreen(theme));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [theme]);
  const { dashuser } = useParams()
  const { vendorId, franchiseId, companyId, operatorId } = authenticationService.getVendorFranchiseIds();
  const API_URL = process.env.REACT_APP_BASE_API_URL;

  const accountType = localStorage.getItem('accountType');
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [opensendpassword, setOpensendpassword] = useState<any>(false);
  const [opensendpasswordID, setOpensendpasswordID] = useState<any>(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [editedUser, setEditedUser] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState('');
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [onmessage, setOnMessage] = useState('');
  const [messageSent, setMessageSent] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const [selectAll, setSelectAll] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);



  
  const [searchQuery, setSearchQuery] = useState('');
 
  const [firstNameOptions, setFirstNameOptions] = useState([]);
  const [lastNameOptions, setLastNameOptions] = useState([]);
  const [emailOptions, setEmailOptions] = useState([]);
  const [phoneOptions, setPhoneOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);


  const [position, setSelectedPosition] = useState('');
  const [posX, setPosXState] = useState('');
  const [posY, setPosYState] = useState('');

  const [openMessageAllDialog, setOpenMessageAllDialog] = useState(false);

 
  const [showUserDetails, setShowUserDetails] = useState(false);
 
  const [routeStatusFilter, setRouteStatusFilter] = useState('');



  const [franchiseOptions, setFranchiseOptions] = useState([]);


  //hide filters for mobile 
  const [showSearch, setShowSearch] = useState(false);
  const [showDateFilters, setShowDateFilters] = useState(false);
  const [showFranchise, setShowFranchise] = useState(false);
  const [expandedCards, setExpandedCards] = useState({});
  const [visibleCount, setVisibleCount] = useState(10);

  //dynamic fields
  const [openFieldDialog, setOpenFieldDialog] = useState(false);
  const [selectedFields, setSelectedFields] = useState({});
  const [dynamic,setDynamic] = useState()
  const [dynamicid,setDynamicid] = useState()
  
  const [deleteLoading, setDeleteLoading] = useState(false);



  const [openUpdateDeviceDialog, setOpenUpdateDeviceDialog] = useState(false);
  const [deviceUpdateData, setDeviceUpdateData] = useState({
    userId: null,
    userName: null,
    existingDeviceId: '',
    oldDeviceStatus: '',
    newDeviceId: '',
    newDeviceStatus: '',
    reason: ''
  });

  const [operatorList, setOperatorList] = useState([]);

  const [loadingOperators, setLoadingOperators] = useState(false);


  
 
  //devicedetails
  const [openDeviceInfoDialog, setOpenDeviceInfoDialog] = useState(false);
  const [selectedDeviceInfo, setSelectedDeviceInfo] = useState({
  name: '',
  id: '',
  deviceType: '',
  deviceOS: '',
  vendorId: '',
  isActive: false,
  lastLogin: ''
});

  
  

  const [deviceInfoLoading, setDeviceInfoLoading] = useState(false);

const handleDeviceInfo = async (row) => {
  try {
    setDeviceInfoLoading(true);

    const response = await get(
      `${API_URL}/api/logged-in-devices/vendor/${vendorId}/getByUserId?userId=${row.userId}`
    );

    const device = response?.[0];

    setSelectedDeviceInfo({
  name: device?.deviceName || '-',
  id: device?.deviceId || '-',
  deviceType: device?.deviceType || '-',
  deviceOS: device?.deviceOS || '-',
  vendorId: device?.vendorId || '-',
  isActive: device?.isActive ?? false,
  lastLogin: device?.lastLogin || '-'
});

    setOpenDeviceInfoDialog(true);
  } catch (error) {
    console.error(error);
    showSnackbar('Failed to fetch device information', 'error');
  } finally {
    setDeviceInfoLoading(false);
  }
};

  


  const getOperatorList = async () => {
    try {
      setLoadingOperators(true);
      let response = null;
      let operatorsList = [];
      if (accountType === "OWNER") {
        response = await get(`${API_URL}/api/operators/vendor/${vendorId}/getOperatorAccountTypeList`);
        operatorsList = (response?.data || []);
        operatorsList = operatorsList.filter(op => (op.accountType === "LCO"));
      } else if (accountType === "DISTRIBUTOR") {
        response = await get(`${API_URL}/api/operators/vendor/${vendorId}/getByDistributorId`, {
          params: { distributorId: operatorId }
        });
        operatorsList = (response?.data || []);
      }

      setOperatorList(operatorsList);
    } catch (error) {
      if (error?.response?.status === 404) {
        setOperatorList([]);
      } else {
        showSnackbar(error?.message || 'Failed to fetch operators', 'error');
      }
    } finally {
      setLoadingOperators(false);
    }
  };

  const getfields = async () => {
  try {
    const res = await get(`${API_URL}/api/input-fields`);

    if (res?.length > 0) {
      const userConfig = res.find(item => item.module === 'USER');
      
      if (userConfig) {
       const parsedFields = JSON.parse(userConfig.fields);
       const id = userConfig?.id
       
        setDynamic(parsedFields);
        setSelectedFields(parsedFields);
        setDynamicid(id);
        
        console.log('dynamic2',dynamic)
      }
    }
  } catch (err) {
    console.error("Error fetching fields", err);
  }
};

  useEffect(() => {
    getOperatorList();
    getfields();
  }, []);

  

  useEffect(() => {
    if (!dashuser) return;

    console.log('Route user status:', dashuser);

    switch (dashuser.toLowerCase()) {
      case 'active':
        setRouteStatusFilter('ACTIVE');
        break;

      case 'inactive':
        setRouteStatusFilter('INACTIVE');
        break;

      case 'blocked':
        setRouteStatusFilter('BLOCKED');
        break;

      default:
        setRouteStatusFilter('');
    }
  }, [dashuser]);

  const getRowId = (user) => user.userId;

  const fetchUserData = async () => {
    try {

      let response = null;
      if (accountType !== null && accountType !== undefined && accountType.trim() === "OWNER") {
        response = await get(`${API_URL}/api/subscriber/vendor/${vendorId}/getSubscribersByVendor`);
      } else if (accountType !== null && accountType !== undefined && accountType.trim() === "DISTRIBUTOR") {
        response = await get(`${API_URL}/api/subscriber/vendor/${vendorId}/franchise/${franchiseId}/getSubscribersByFranchise`);
      } else {
        let payload = { 'assignedTo': operatorId };
        response = await get(`${API_URL}/api/subscriber/vendor/${vendorId}/franchise/${franchiseId}/getSubscribersByFranchise`, { params: payload });
      }


      console.log(response.userList);
      console.log('Fetched data:', response.userList);
      const responseData = (response.userList != null) ? response.userList : []



      setTableData(responseData);
    } catch (error) {
      console.error('Error fetching User data:', error);
    }
  };



  useEffect(() => {
    fetchUserData();
  }, []);

  const handleExportXLS = () => {
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscribers");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Subscribers_data.xlsx";
    link.click();
  };

  const convertToXML = (data) => {
    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n<users>\n';
    data.forEach((user) => {
      xml += `  <user>\n`;
      xml += `    <id>${user.userId}</id>\n`;
      xml += `    <firstName>${user.firstName}</firstName>\n`;
      xml += `    <lastName>${user.lastName}</lastName>\n`;

      xml += `    <email>${user.email}</email>\n`;
      xml += `    <phone>${user.phone}</phone>\n`;
      xml += `    <franchiseName>${user.franchiseName}</franchiseName>\n`;
      xml += `    <aadharNumber>${user.aadharNumber || ''}</aadharNumber>\n`; // <-- Added Aadhaar
      xml += `    <address>${user.address}</address>\n`;
      xml += `    <status>${user.status}</status>\n`;
      xml += `    <registeredDate>${user.registeredDate}</registeredDate>\n`;
      xml += `    <devices>${user.devices}</devices>\n`;
      xml += `  </user>\n`;
    });
    xml += "</users>";
    return xml;
  };

  const handleExportXML = () => {
    const xmlData = convertToXML(tableData);
    const blob = new Blob([xmlData], { type: "application/xml" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "users_data.xml";
    link.click();
  };

  const handleOpenAddDialog = () => {
    
  };


  const handleSearch = (e) => {
    setSearchQuery(e.target.value); // Remove .toLowerCase() here
  };


  useEffect(() => {
    const extractUniqueValues = (key) => {
      const uniqueValues = new Set(tableData.map((user) => user[key]));
      return Array.from(uniqueValues);
    };

    const uniqueFranchises = [
      'OWNER',
      ...new Set(
        tableData
          .map(user => user.franchiseName)
          .filter(name => name && name.trim() !== '')
      )
    ];

    setFranchiseOptions(uniqueFranchises);

    setFirstNameOptions(extractUniqueValues('firstName'));

    setLastNameOptions(extractUniqueValues('lastName'));
    setEmailOptions(extractUniqueValues('email'));
    setPhoneOptions(extractUniqueValues('phone'));
    setStatusOptions(extractUniqueValues('status'));
  }, [tableData]);

  const getFilteredRows = useMemo(() => {
    return () => {
      let filteredRows = tableData;

      // Show only INACTIVE and EXPIRED users
filteredRows = filteredRows.filter(
  (row) =>
    row.userStatus?.toUpperCase() === 'INACTIVE' 
);   

filteredRows = filteredRows.filter(
  (row) =>
    row.subscriptionStatus?.toUpperCase() === 'INACTIVE' 
);  


      if (searchQuery) {
        filteredRows = tableData.filter((row) =>
          Object.values(row).some(
            (value) => value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
          )
        );
      }

      
      

      
      

      return filteredRows;
    };
  }, [tableData, searchQuery]);

  const filteredRows = getFilteredRows();
  const visibleRows = filteredRows.slice(0, visibleCount);

 

  const editUser = (userData) => {
    setEditedUser(userData);
    setOpenEditDialog(true);
  };

  /* FOR SEND PASSWORD */
  const sendpassword = (passId) => {
    setOpensendpassword(true)
    setOpensendpasswordID(passId)
  };


  const deleteUser = (userId) => {
    setDeleteConfirmationId(userId);
    setOpenDeleteConfirmation(true);
  };

  const handleSnackbarClose = (event: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };



 

  const handleCheckboxChange = (userId) => {
    setSelectedUsers(prevSelected => {
      if (prevSelected.includes(userId)) {
        return prevSelected.filter(id => id !== userId);
      } else {
        return [...prevSelected, userId];
      }
    });
  };

  

  // new user details handle code 

  
  const handleUserDetails = (userId) => {
    navigate(`/ottusers/subscriber-hardware-and-channel/${userId}`);
  };

  


  // Update the selectAll state
  useEffect(() => {
    const allSelected = filteredRows.length > 0 &&
      filteredRows.every(row => selectedUsers.includes(row.userId));
    setSelectAll(allSelected);
  }, [selectedUsers, filteredRows]);

  const navigate = useNavigate();

  const columns = [

    { field: 'userId', headerName: 'ID' },
    { field: 'customerId', headerName: 'Customer ID', width: 200  },
    { field: 'firstName', headerName: 'First Name', width: 100 },
    //{ field: 'lastName', headerName: 'Last Name', width: 100 },
    { field: 'userName', headerName: 'User Name', width: 100 },
    // ...(hasCustomPasswordAccess
    // ? [{ field: 'userPassword', headerName: 'Password', width: 100 }]
    // : []),


    { field: 'email', headerName: 'Email', width: 150 },
    { field: 'phone', headerName: 'Phone', width: 150 },
    { field: 'userStatus', headerName: 'UserStatus', width: 150 },
    
    {
      field: 'operatorName',
      headerName: 'LCO',
      width: 200,
      valueGetter: (params) => params.row.assignedTo?.operatorName || '-',
    },
    /* {
      field: 'aadharNumber', // <-- Added Aadhaar column
      headerName: 'Aadhaar Number',
      width: 130,
      valueGetter: (params) => params.row.aadharNumber || '-',
    } */,
    //{ field: 'walletAmount', headerName: 'Wallet', width: 100 },
    //{ field: 'installationAddress', headerName: 'Installation Address', width: 200 },
    //{ field: 'billingAddress', headerName: 'Billing Address', width: 200 },
    { field: 'subscriptionStatus', headerName: 'Subscription Status', width: 100 },
    //{ field: 'fingerprintStatus', headerName: 'Fingerprint Status', width: 100 },
    /* {
      field: 'registeredDate',
      headerName: 'Registered Date',
      width: 150,
      valueFormatter: (params) =>
        params.value ? format(new Date(params.value), 'dd/MM/yyyy') : '',
    } */,
    { field: 'devices', headerName: 'Device ID', width: 150 },
    { field: 'deviceStatus', headerName: 'Device Status', width: 100 },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      width: 220,
      renderCell: (params) => (
        <div>

        {(accountType === 'LCO') && <IconButton onClick={() => handleOpenUpdateDeviceDialog(params.row)} color="info">
            <DeviceHubIcon /> 
          </IconButton>}  


        {
          (accountType === 'LCO' || hasPermission(["OWNER", "subscriber.view"])) && <IconButton onClick={() => handleUserDetails(params.row.userId)} color="success" title="User Details">
            <PermIdentityIcon />
          </IconButton>
        }
          

          
          <IconButton
  onClick={() => handleDeviceInfo(params.row)}
  color="primary"
  title="Device Info"
>
  <InfoIcon />
</IconButton>
          {/* {
            hasPermission(["subscriber.delete"]) &&
            <IconButton onClick={() => deleteUser(params.row.userId)} style={{ color: red[500] }}>
              <DeleteIcon />
            </IconButton>
          } */}
        </div>
      ),
    },
  ];

  //const filteredColumns = columns;

  const filteredColumns = useMemo(() => {
  if (!dynamic) return columns;

  return columns.filter(col => {
    if (col.field === 'actions') return true; // always show actions

    return dynamic[col.field] !== false; // show only true fields
  });
}, [columns, dynamic]);



  const fetchRegistrationToken = async (userId) => {
    try {
      const response = await get(`${API_URL}/registrationtoken?userId=${userId}`);
      return response.data.RegistrationToken;
    } catch (error) {
      console.error('Error fetching registration token:', error);
      throw error;
    }
  };

  const handleSendMessage = async (
    message: string,
    posX: string,
    posY: string,
    position: string
  ) => {
    console.log('[handleSendMessage] Starting request with:', {
      message, posX, posY, position
    });

    try {
      console.log('[handleSendMessage] Fetching registration token...');
      const registrationToken = await fetchRegistrationToken(selectedUserId);

      if (!registrationToken) {
        console.error('[handleSendMessage] No registration token found');
        throw new Error('No registration token found for this user');
      }

      console.log('[handleSendMessage] Making API request with token:', registrationToken);
      const response = await axios.post(
        `${API_URL}/clients/${registrationToken}`,
        {
          data: {
            posX: posX,
            posY: posY,
            position: position,
            message: message,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        }
      );

      console.log('[handleSendMessage] API Response:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data,
        headers: response.headers
      });

      if (response.status === 202) {
        console.log('[handleSendMessage] Request successful (202 Accepted)');
        setMessageSent(true);
        setSnackbarSeverity('success');
        setSnackbarMessage('Message sent successfully!');
        setOnMessage('');
        setPosXState('');
        setPosYState('');
        setSelectedPosition('');
        setMessageError('');
      } else {
        console.warn('[handleSendMessage] Unexpected status code:', response.status);
        throw new Error(`Server returned status: ${response.status}`);
      }
    } catch (error) {
      console.group('[handleSendMessage] Error occurred');
      console.error('Error object:', error);

      let errorMessage = 'Error sending message. Please try again.';

      if (axios.isAxiosError(error)) {
        console.log('Axios error detected');
        console.log('Has response:', !!error.response);
        console.log('Has request:', !!error.request);

        type ErrorResponseData = {
          message?: string;
        };

        const responseData = error.response?.data as ErrorResponseData | undefined;

        if (error.response) {
          console.log('Error response:', {
            status: error.response.status,
            data: error.response.data,
            headers: error.response.headers
          });

          errorMessage = `Server error: ${error.response.status}`;
          if (responseData?.message) {
            errorMessage += ` - ${responseData.message}`;
          }
        } else if (error.request) {
          console.log('No response received, request object:', error.request);
          errorMessage = 'No response from server';
        }
      } else if (error instanceof Error) {
        console.log('Standard Error:', error.message);
        errorMessage = error.message;
      } else {
        console.log('Unknown error type:', error);
      }

      console.groupEnd();

      setMessageError(errorMessage);
      setSnackbarSeverity('error');
      setSnackbarMessage(errorMessage);
    } finally {
      console.log('[handleSendMessage] Finalizing request (opening snackbar)');
      setOpenMessageDialog(false);
      setOpenSnackbar(true);
    }
  };



  const handleSendMessageToAll = async (message, posX, posY, position) => {
    try {
      if (selectedUsers.length === 0) {
        setSnackbarSeverity('warning');
        setSnackbarMessage('No users selected!');
        setOpenSnackbar(true);
        return;
      }

      const tokenPromises = selectedUsers.map(userId => fetchRegistrationToken(userId));
      const tokenResults = await Promise.all(tokenPromises);
      const tokens = tokenResults.filter(token => token);

      if (tokens.length === 0) {
        throw new Error('No valid registration tokens found for selected users');
      }

      const response = await axios.post(
        `${API_URL}/send-notification`,
        {
          userIds: selectedUsers,
          data: {
            posX: posX,
            posY: posY,
            position: position,
            message: message,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        }
      );

      console.log('Response status:', response.status); // Should log 200
      console.log('Response data:', response.data); // Should log success message

      // Handle 200 (Success)
      if (response.status === 200) {
        setSnackbarSeverity('success');
        setSnackbarMessage(`Messages sent successfully!`);
        setOnMessage('');
        setPosXState('');
        setPosYState('');
        setSelectedPosition('');
      } else {
        throw new Error(`Unexpected status: ${response.status}`);
      }
    } catch (error) {
      let errorMessage = 'Error sending messages';

      // Type-safe error handling
      if (axios.isAxiosError(error)) {
        // Define the expected error response shape
        type ErrorResponseData = {
          message?: string;
        };

        // Type assertion for the response data
        const responseData = error.response?.data as ErrorResponseData | undefined;

        if (error.response) {
          errorMessage = `Server error: ${error.response.status}`;
          if (responseData?.message) {
            errorMessage += ` - ${responseData.message}`;
          }
        } else if (error.request) {
          errorMessage = 'No response from server';
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      setSnackbarSeverity('error');
      setSnackbarMessage(errorMessage);
      console.error('Error details:', error);
    } finally {
      setOpenMessageAllDialog(false);
      setOpenSnackbar(true);
    }
  };




  const handleOpenUpdateDeviceDialog = (userData) => {
    if (!userData.devices) {
      showSnackbar('This user has no device assigned', 'error')

      return;
    }

    setDeviceUpdateData({
      userId: userData.userId,
      userName: userData.email,
      existingDeviceId: userData.devices || '',
      oldDeviceStatus: userData.deviceStatus || '',
      newDeviceId: '',
      newDeviceStatus: userData.status || '', // Initialize with current status
      reason: ''
    });
    setOpenUpdateDeviceDialog(true);
  };

  const handleDeviceUpdate = async () => {
    setdeviceloading(true)
    try {

      const response = await post(`${API_URL}/api/subscriber/vendor/${vendorId}/un_pair_device`, new URLSearchParams({
        userId: deviceUpdateData.userId,
        userName: deviceUpdateData.userName,
        oldDeviceId: deviceUpdateData.existingDeviceId,
        oldDeviceStatus: deviceUpdateData.oldDeviceStatus,
        // newDeviceId: deviceUpdateData.newDeviceId,
        // newDeviceStatus: deviceUpdateData.newDeviceStatus,
        reasonForChange: deviceUpdateData.reason
      }));
      //console.log(response)
      if (response?.responseCode === "200") {
        setdeviceloading(false)
        fetchUserData();
        await fetchOperatorDetails();

        setOpenUpdateDeviceDialog(false);
        showSnackbar(response?.responseMessage, 'success')
      } else {
        showSnackbar('Failed to update device', 'error')
        throw new Error(response?.responseMessage || 'Failed to update device');

      }
    } catch (error) {
      if (error['response']['data']['responseCode'] != undefined && error['response']['data']['responseCode'] != "") {
        showSnackbar(error['response']['data']['responseMessage'], 'error')
      } else {
        showSnackbar(error, 'error')
      }
      console.log(error)
    }finally {
    setdeviceloading(false);
  }
  };

  /* SEND PASSOWRD HANDLE FUNCTION */

 

  //dynamic fields
   useEffect(() => {
  const initialFields = {};
  columns.forEach(col => {
    if (col.field !== 'actions') {
      initialFields[col.field] = true; // default checked
    }
  });
  setSelectedFields(initialFields);
}, []);

const handleFieldToggle = (field) => {
  setSelectedFields(prev => ({
    ...prev,
    [field]: !prev[field]
  }));
};



//multiple subscription
const handleMultiSubscription = () => {

   if (selectedUsers.length < 2) {
    showSnackbar(
      "Please select at least 2 subscribers for multiple subscription",
      "error"
    );
    return;
  }
  const selectedSubscribers = tableData.filter((user) =>
    selectedUsers.includes(user.userId)
  );

  const invalidSubscribers = selectedSubscribers.filter(
    (user) =>
      !user.assignedTo 
  );

  if (invalidSubscribers.length > 0) {
    const pendingList = invalidSubscribers
      .map(
        (user) =>
          `${user.firstName} ${user.lastName} (${user.customerId})`
      )
      .join(", ");

    showSnackbar(
      `Subscription pending or LCO not assigned: ${pendingList}`,
      "error"
    );
    return;
  }

 

  const selectedSubscribersData = tableData.filter((user) =>
  selectedUsers.includes(user.userId)
);

const subscriptionType =
  selectedSubscribersData[0]?.subscriptionStatus || "";

// Check subscription status
const subscriptionStatuses = [
  ...new Set(
    selectedSubscribersData.map((user) =>
      user.subscriptionStatus?.toUpperCase()
    )
  ),
];

if (subscriptionStatuses.length > 1) {
  showSnackbar(
    "Please select subscribers with the same subscription status only (EXPIRED or INACTIVE)",
    "error"
  );
  return;
}

  navigate("/ottusers/multiplesubscription", {
    state: {
    selectedUserIds: selectedUsers,
    customerIds: selectedSubscribersData.map(
      (user) => user.customerId
    ),
    subscriptionType,
  },
  });
};


  return (
    <>

    {/* device info dialog */}
    <Dialog
  open={openDeviceInfoDialog}
  onClose={() => setOpenDeviceInfoDialog(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Device Information</DialogTitle>

  <DialogContent>
    {deviceInfoLoading ? (
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <CircularProgress />
      </Box>
    ) : (
      <>
        <TextField
          fullWidth
          margin="normal"
          label="Device Name"
          value={selectedDeviceInfo.name}
          InputProps={{ readOnly: true }}
        />
         
        <TextField
          fullWidth
          margin="normal"
          label="Device ID"
          value={selectedDeviceInfo.id}
          InputProps={{ readOnly: true }}
        />

        <TextField
          fullWidth
          margin="normal"
          label="deviceType"
          value={selectedDeviceInfo.deviceType}
          InputProps={{ readOnly: true }}
        />

        <TextField
  fullWidth
  margin="normal"
  label="Device OS"
  value={selectedDeviceInfo.deviceOS}
  InputProps={{ readOnly: true }}
/>



<TextField
  fullWidth
  margin="normal"
  label="Status"
  value={selectedDeviceInfo.isActive ? 'ACTIVE' : 'INACTIVE'}
  InputProps={{ readOnly: true }}
/>

<TextField
  fullWidth
  margin="normal"
  label="Last Login"
  value={selectedDeviceInfo.lastLogin}
  InputProps={{ readOnly: true }}
/>
      </>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenDeviceInfoDialog(false)}>
      Close
    </Button>
  </DialogActions>
</Dialog>

      

      

      {/* 📱 MOBILE (OUTSIDE PageTitleWrapper) */}
      <Box sx={styles.mobileHeader}>
        {/* TITLE */}
        <Typography sx={styles.mobileTitle}>
          Multiple Subscriptions
        </Typography>

        {/* ACTIONS */}
        <Box sx={styles.mobileHeaderActions}>

          {/* ADD BUTTON */}
          {hasPermission(["OWNER", "subscriber.create"]) && (
            <Button
              variant="contained"
              startIcon={<PersonAddAltIcon />}
              onClick={handleOpenAddDialog}
              sx={styles.mobileAddButton}
            >
              Add
            </Button>
          )}

        </Box>

      </Box>

      <Box sx={styles.mobileFilterBar}>

        {/* 🔍 SEARCH */}
        <Button
          variant="contained"
          onClick={() => setShowSearch(prev => !prev)}
          sx={{
            ...styles.mobileIconButton,
            backgroundColor: showSearch ? '#1976d2' : '#90caf9',
            '&:hover': { backgroundColor: '#115293' }
          }}
        >
          <SearchIcon fontSize="small" />
        </Button>

        {/* 📅 DATE */}
        <Button
          variant="contained"
          onClick={() => setShowDateFilters(prev => !prev)}
          sx={{
            ...styles.mobileIconButton,
            backgroundColor: showDateFilters ? '#ed6c02' : '#ffcc80',
            '&:hover': { backgroundColor: '#e65100' }
          }}
        >
          <DateRangeIcon fontSize="small" />
        </Button>

        {/* 🏢 FRANCHISE */}
        <Button
          variant="contained"
          onClick={() => setShowFranchise(prev => !prev)}
          sx={{
            ...styles.mobileIconButton,
            backgroundColor: showFranchise ? '#2e7d32' : '#a5d6a7',
            '&:hover': { backgroundColor: '#1b5e20' }
          }}
        >
          <BusinessIcon fontSize="small" />
        </Button>

        {/* XLS */}
        <Button
          onClick={handleExportXLS}
          sx={{
            ...styles.mobileSmallIconButton,
            backgroundColor: '#2e7d32',
            '&:hover': { backgroundColor: '#1b5e20' }
          }}
        >
          <DownloadIcon fontSize="small" />
        </Button>

        {/* XML */}
        <Button
          onClick={handleExportXML}
          sx={{
            ...styles.mobileSmallIconButton,
            backgroundColor: '#7b1fa2',
            '&:hover': { backgroundColor: '#4a148c' }
          }}
        >
          <DownloadIcon fontSize="small" />
        </Button>

      </Box>

      {/* 💻 DESKTOP (UNCHANGED) */}
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <PageTitleWrapper>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <Box>
              <PageTitle
                heading="Multiple Subscription"
                subHeading="Multiple Subscriptions."
                handleClick={handleOpenAddDialog}
              />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              

              {accountType === "LCO" && (
  <Button
    variant="contained"
    color="secondary"
    startIcon={<SubscriptionsIcon />}
    disabled={selectedUsers.length === 0}
    onClick={handleMultiSubscription}
  >
    MultySubscription
  </Button>
)}

              <Button
                variant="contained"
                onClick={handleExportXLS}
                startIcon={<DownloadIcon />}
              >
                Export to XLS
              </Button>

              <Button
                variant="contained"
                onClick={handleExportXML}
                startIcon={<DownloadIcon />}
              >
                Export to XML
              </Button>
            </Box>
          </Box>
        </PageTitleWrapper>
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          width: '100%',
          padding: '0 15px',
          marginTop: 2,

          // 📱 MOBILE → COLUMN
          flexDirection: { xs: 'column', sm: 'row' }
        }}
      >
        {/* SEARCH */}
        {(showSearch || window.innerWidth >= 600) && (
          <TextField
            label="Search"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearch}
            
          />
        )}

        

        

        {/* FRANCHISE */}
        {/* {(showFranchise || window.innerWidth >= 600) && accountType === 'OWNER' && (
          <FormControl fullWidth>
            <InputLabel>Franchise Users</InputLabel>
            <Select
              value={franchiseFilter}
              onChange={(e) => setFranchiseFilter(e.target.value)}
              label="Franchise Filter"
            >
              <MenuItem value="">All</MenuItem>
              {franchiseOptions.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */}
      </Box>

      

      
      

      

      <Box
        sx={{
          height: 'calc(100vh - 220px)',
          width: '100%',
          padding: '15px'
        }}
      >
       
          <>
            {isMobile ? (
              // ===================== 📱 MOBILE VIEW =====================
              <Box sx={styles.mobileCardContainer}>
                {visibleRows.map((row) => {
                  const isExpanded = expandedCards[row.userId];

                  return (
                    <Box key={row.userId} sx={styles.mobileCard}>

                      {/* 🔹 HEADER */}
                      <Box sx={styles.mobileCardHeader}>
                        <Box>
                          <Typography sx={styles.mobileCardTitle}>
                            {row.firstName} {row.lastName}
                          </Typography>
                          <Typography sx={styles.mobileCardSubText}>
                            ID: {row.userId}
                          </Typography>
                        </Box>

                        <Checkbox
                          checked={selectedUsers.includes(row.userId)}
                          onChange={() => handleCheckboxChange(row.userId)}
                        />
                      </Box>

                      {/* 🔹 EMAIL */}
                      <Typography sx={{ ...styles.mobileCardText, mt: 1, opacity: 0.85 }}>
                        📧 {row.email}
                      </Typography>

                      {/* 🔹 PHONE */}
                      <Typography sx={{ ...styles.mobileCardText, mt: 0.5 }}>
                        📞 {row.phone}
                      </Typography>

                      {/* 🔹 STATUS */}
                      <Box
                        sx={{
                          ...styles.mobileCardStatus,
                          backgroundColor:
                            row.status === 'ACTIVE'
                              ? '#2e7d32'
                              : row.status === 'INACTIVE'
                                ? '#ed6c02'
                                : '#d32f2f'
                        }}
                      >
                        {row.status}
                      </Box>

                      {/* 🔽 EXPAND BUTTON */}
                      <Box sx={{ mt: 1 }}>
                        <Button
                          size="small"
                          onClick={() =>
                            setExpandedCards((prev) => ({
                              ...prev,
                              [row.userId]: !prev[row.userId]
                            }))
                          }
                        >
                          {isExpanded ? 'Hide Details' : 'View More'}
                        </Button>
                      </Box>

                      {/* 🔽 DETAILS */}
                      {isExpanded && (
                        <Box sx={{ mt: 1.5, fontSize: '13px', opacity: 0.9 }}>
                          <Typography>Franchise: {row.franchiseName || '-'}</Typography>
                          <Typography>Wallet: ₹{row.walletAmount || 0}</Typography>
                          <Typography>Registered: {row.registeredDate || '-'}</Typography>
                          <Typography>Aadhar: {row.aadharNumber || '-'}</Typography>
                           <Typography>Installation Address: {row.installationAddress || '-'}</Typography>
                        </Box>
                      )}

                      {/* 🔹 ACTIONS */}
                      <Box sx={styles.mobileCardActions}>

                        <IconButton onClick={() => handleOpenUpdateDeviceDialog(row)} size="small" sx={{ color: '#64b5f6' }}>
                          <DeviceHubIcon />
                        </IconButton>

                        <IconButton onClick={() => handleUserDetails(row.userId)} size="small" sx={{ color: '#4fc3f7' }}>
                          <PermIdentityIcon />
                        </IconButton>

                        {hasPermission(["OWNER"]) && (
                          <IconButton onClick={() => sendpassword(row)} size="small" sx={{ color: '#fff' }}>
                            <LockOpenIcon />
                          </IconButton>
                        )}

                        {hasPermission(["OWNER", "subscriber.edit"]) && (
                          <IconButton onClick={() => editUser(row)} size="small" sx={{ color: '#81c784' }}>
                            <EditIcon />
                          </IconButton>
                        )}

                        {/* {hasPermission(["OWNER", "subscriber.delete"]) && (
                          <IconButton onClick={() => deleteUser(row.userId)} size="small" sx={{ color: '#e57373' }}>
                            <DeleteIcon />
                          </IconButton>
                        )} */}

                      </Box>
                    </Box>
                  );
                })}

                {/* 🔹 LOAD MORE */}
                {visibleCount < filteredRows.length && (
                  <Box sx={styles.mobileLoadMore}>
                    <Button
                      variant="contained"
                      onClick={() => setVisibleCount((prev) => prev + 10)}
                    >
                      Load More ({visibleRows.length}/{filteredRows.length})
                    </Button>
                  </Box>
                )}
              </Box>
            ) : (
              // ===================== 💻 DESKTOP VIEW =====================
              <>
                <DataGrid
                  rows={filteredRows}
                  columns={filteredColumns}
                  getRowId={getRowId}
                  checkboxSelection
                  disableSelectionOnClick
                  onSelectionModelChange={(newSelection) => {
                    setSelectedUsers(newSelection);
                  }}
                  selectionModel={selectedUsers}
                  sx={{
                    boxShadow: 2,
                    border: 2,
                    borderColor: 'rgb(43 44 45)'
                  }}
                />


              </>
            )}
          </>
      
      </Box>

      

      <Dialog
        open={openMessageDialog}
        onClose={() => {
          setOpenMessageDialog(false);
          setMessageSent(false);
          setMessageError('');
          setOnMessage('');
          setPosXState('');
          setPosYState('');
          setSelectedPosition('');
        }}
        aria-labelledby="message-dialog-title"
        aria-describedby="message-dialog-description"
      >
        <DialogTitle id="message-dialog-title">Send Message</DialogTitle>
        <DialogContent>
          <TextField
            label="Type your message"
            variant="outlined"
            value={onmessage}
            onChange={(e) => setOnMessage(e.target.value)}
            style={{ width: '300px', marginBottom: '20px' }}
          />
          <TextField
            label="Enter posX"
            variant="outlined"
            value={posX}
            onChange={(e) => setPosXState(e.target.value)}
            style={{ width: '300px', marginBottom: '20px' }}
          />
          <TextField
            label="Enter posY"
            variant="outlined"
            value={posY}
            onChange={(e) => setPosYState(e.target.value)}
            style={{ width: '300px', marginBottom: '20px' }}
          />
          <InputLabel id="position-select-label">Select Position</InputLabel>
          <Select
            labelId="position-select-label"
            id="position-select"
            value={position}
            onChange={(e) => setSelectedPosition(e.target.value)}
            style={{ width: '300px', marginTop: '20px' }}
          >
            <MenuItem value="Right">Right</MenuItem>
            <MenuItem value="Left">Left</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMessageDialog(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleSendMessage(onmessage, posX, posY, position);
            }}
            color="primary"
            autoFocus
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMessageAllDialog}
        onClose={() => {
          setOpenMessageAllDialog(false);
          setOnMessage('');
          setPosXState('');
          setPosYState('');
          setSelectedPosition('');
        }}
        aria-labelledby="message-all-dialog-title"
        aria-describedby="message-all-dialog-description"
      >
        <DialogTitle id="message-all-dialog-title">Send Message to Selected Users ({selectedUsers.length})</DialogTitle>
        <DialogContent>
          <TextField
            label="Type your message"
            variant="outlined"
            value={onmessage}
            onChange={(e) => setOnMessage(e.target.value)}
            style={{ width: '300px', marginBottom: '20px' }}
          />
          <TextField
            label="Enter posX"
            variant="outlined"
            value={posX}
            onChange={(e) => setPosXState(e.target.value)}
            style={{ width: '300px', marginBottom: '20px' }}
          />
          <TextField
            label="Enter posY"
            variant="outlined"
            value={posY}
            onChange={(e) => setPosYState(e.target.value)}
            style={{ width: '300px', marginBottom: '20px' }}
          />
          <InputLabel id="position-select-label">Select Position</InputLabel>
          <Select
            labelId="position-select-label"
            id="position-select"
            value={position}
            onChange={(e) => setSelectedPosition(e.target.value)}
            style={{ width: '300px', marginTop: '20px' }}
          >
            <MenuItem value="Right">Right</MenuItem>
            <MenuItem value="Left">Left</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMessageAllDialog(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleSendMessageToAll(onmessage, posX, posY, position);
            }}
            color="primary"
            autoFocus
          >
            Send to All Selected
          </Button>
        </DialogActions>
      </Dialog>

     





      <Dialog
        open={openUpdateDeviceDialog}
        onClose={() => setOpenUpdateDeviceDialog(false)}
        aria-labelledby="update-device-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="update-device-dialog-title">Update Device Information</DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Current Device Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="User ID"
                  fullWidth
                  variant="outlined"
                  value={deviceUpdateData.userId || ''}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="User Name"
                  fullWidth
                  variant="outlined"
                  value={deviceUpdateData.userName || ''}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  margin="dense"
                  label="Current Device ID"
                  fullWidth
                  variant="outlined"
                  value={deviceUpdateData.existingDeviceId || ''}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth margin="dense" variant="outlined">
                  <Select
                    value={deviceUpdateData.oldDeviceStatus || ''}
                    // onChange={(e) => setDeviceUpdateData({ ...deviceUpdateData, oldDeviceStatus: e.target.value })}
                    onChange={ async (e) => { 
                      setDeviceUpdateData({ ...deviceUpdateData, oldDeviceStatus: e.target.value });
                    }}
                    label="New Status *"
                    required
                  >
                    <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                    <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                    <MenuItem value="INSTOCK">INSTOCK</MenuItem>
                    <MenuItem value="DAMAGED">DAMAGED</MenuItem>
                    <MenuItem value="REPAIRED">REPAIRED</MenuItem>
                    <MenuItem value="REPLACED">REPLACED</MenuItem>
                    <MenuItem value="BLACKLIST">BLACKLIST</MenuItem>
                    <MenuItem value="FAULTY">FAULTY</MenuItem>
                    <MenuItem value="SUSPEND">SUSPEND</MenuItem>
                  </Select>
                </FormControl>

              </Grid>
            </Grid>
          </Box>

          {/* <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              New Device Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  margin="dense"
                  label="New Device ID (Optional)"
                  fullWidth
                  variant="outlined"
                  value={deviceUpdateData.newDeviceId || ''}
                  onChange={(e) => setDeviceUpdateData({ ...deviceUpdateData, newDeviceId: e.target.value })}
                  disabled={deviceUpdateData.oldDeviceStatus === 'ACTIVE'}
                  helperText="Leave blank to keep current device"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth margin="dense" variant="outlined">
                  <InputLabel>New Status *</InputLabel>
                  <Select
                    value={deviceUpdateData.newDeviceStatus || ''}
                    onChange={(e) => setDeviceUpdateData({ ...deviceUpdateData, newDeviceStatus: e.target.value })}
                    label="New Status *"
                    required
                  >
                    <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                    <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                    <MenuItem value="INSTOCK">INSTOCK</MenuItem>
                    <MenuItem value="DAMAGED">DAMAGED</MenuItem>
                    <MenuItem value="REPAIRED">REPAIRED</MenuItem>
                    <MenuItem value="REPLACED">REPLACED</MenuItem>
                    <MenuItem value="BLACKLIST">BLACKLIST</MenuItem>
                    <MenuItem value="FAULTY">FAULTY</MenuItem>
                    <MenuItem value="SUSPEND">SUSPEND</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box> */}

          <TextField
            margin="dense"
            label="Reason for Change *"
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            value={deviceUpdateData.reason || ''}
            onChange={(e) => setDeviceUpdateData({ ...deviceUpdateData, reason: e.target.value })}
            required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenUpdateDeviceDialog(false)} color="primary">
            Cancel
          </Button>
          {/* disabled={!deviceUpdateData.reason || !deviceUpdateData.newDeviceStatus} */}
          <Button
  onClick={handleDeviceUpdate}
  color="primary"
  variant="contained"
  disabled={deviceloading}
>
  {deviceloading ? (
    <CircularProgress size={24} color="inherit" />
  ) : (
    "Update Device"
  )}
</Button>
        </DialogActions>
      </Dialog>

      

   
    </>
  );
};

export default Multiplesubscriptions;


